import React from 'react'
import PropTypes from 'prop-types'
import { Button } from '../../section-components/Button'
import { TextboxDesktop } from '../../section-components/Textbox'
import styles from './Form.module.scss'

function FormDesktop({
  t,
  userFields,
  validFields,
  validateChange,
  handleBlur,
  handleSubmit,
  isFormValid,
  onCancel
}) {
  return (
    <div className={styles['edit-account-form']}>
      <label htmlFor="fieldsHeader" className={styles['fields-header']}>{t('fields-required')}</label>
      <div className={styles['form-field']}>
        <label htmlFor="primaryEmail" className={styles['form-label']}>{t('label-email')}</label>
        <span className={styles['form-secondary-text']}>{t('support-text-primary-email')}</span>
        <TextboxDesktop
          disabled
          value={userFields.email}
          onBlur={() => handleBlur('email')}
          error={validFields.email.hasError}
          supportText={t('validation-email')}
          required
        />
      </div>
      <div className={styles['form-field']}>
        <label htmlFor="secondaryEmail" className={styles['form-label']}>{t('label-second-email-optional')}</label>
        <span className={styles['form-secondary-text']}>{t('support-text-second-email')}</span>
        <TextboxDesktop
          value={userFields.secondEmail}
          onChange={(e) => validateChange('secondEmail', e.target.value)}
          onBlur={() => handleBlur('secondEmail')}
          error={validFields.secondEmail.hasError}
          supportText={t('validation-email')}
        />
      </div>

      <div className={styles.buttons}>
        <Button
          text={t('button-save-changes')}
          buttonStyle="cta-red-oval-edit-profile"
          onClick={handleSubmit}
          disabled={!isFormValid}
        />
        <Button
          text={t('button-cancel')}
          buttonStyle="cta-grey-oval"
          onClick={onCancel}
        />
      </div>
    </div>
  )
}

FormDesktop.propTypes = {
  t: PropTypes.func.isRequired,
  userFields: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    secondEmail: PropTypes.string,
    mobilePhone: PropTypes.string,
  }).isRequired,
  validFields: PropTypes.shape({
    firstName: PropTypes.shape({
      isValid: PropTypes.bool,
      hasError: PropTypes.bool,
    }),
    lastName: PropTypes.shape({
      isValid: PropTypes.bool,
      hasError: PropTypes.bool,
    }),
    email: PropTypes.shape({
      isValid: PropTypes.bool,
      hasError: PropTypes.bool,
    }),
    secondEmail: PropTypes.shape({
      isValid: PropTypes.bool,
      hasError: PropTypes.bool,
    }),
    mobilePhone: PropTypes.shape({
      isValid: PropTypes.bool,
      hasError: PropTypes.bool,
    }),
  }).isRequired,
  validateChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  isFormValid: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired
}

export default FormDesktop
